const React = require('react');


module.exports = ({
  label,
  value,
  children,
  ...props
}) => {
  return (
    <div {...props}>
      <div className="c0 f16 fw7 lts0em lh24 h24 ws tov ov">{label}</div>
      <div className="mt4 c717275 f12 lh17 fw3 lts0em layoutRow fhaS fvaS">
        {value || children || null}
      </div>
    </div>
  );
};
